import dayjs from 'dayjs'

/** Exact local date/time for notification list (e.g. `8 May 2026, 11:36 am`). */
export function formatNotificationTimestamp(createdAt?: Date | string | null): string {
  if (createdAt == null || createdAt === '') {
    return '—'
  }
  const d = dayjs(createdAt)
  if (!d.isValid()) {
    return '—'
  }

  return d.format('D MMM YYYY, h:mm a')
}
